import React from 'react';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import InputAdornmentComponent from '../Input-adornment/Input-adornment.component';
import useDictionary from '@ui/hooks/useDictionary';
import { values } from './values';
import { variants } from './variants.enum';
import { IProps } from './IProps';
import parseValue from './parseValue';
import { useRef } from 'react';

const Component: React.FC<IProps> = ({
    lang,
    description,
    disabled,
    helperText,
    id,
    label,
    name,
    value,
    values,
    variant,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
}) => {
    const getWord = useDictionary();
    const _values: values = values ?? [];
    const _label = label ? getWord(label) : undefined;

    let selectClass = 'select';
    let inputClass = 'select__input';
    switch (variant) {
        case variants.footer:
            selectClass = 'select_footer';
            inputClass = 'select__input_footer';
            break;
        case variants.sidebar:
            selectClass = 'select_sidebar';
            break;
    }

    return (
        <FormControl className={selectClass}>
            {typeof _label === 'string' && (
                <InputLabel
                    className="select__label"
                    shrink={value ? true : undefined}
                >
                    {_label}
                </InputLabel>
            )}
            <Select
                className={inputClass}
                disabled={disabled}
                label={_label}
                name={name}
                id={id}
                size="small"
                value={value}
                // inputProps={_label ? {
                //     'aria-label': 'Without label'
                // } : undefined}
                startAdornment={
                    description ? (
                        <InputAdornmentComponent
                            lang={lang}
                            data={description}
                        />
                    ) : undefined
                }
                onChange={onChange}
                onClick={onClick}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
            >
                {_values.map((val) => {
                    const { value, label, span } = parseValue(val);

                    return (
                        <MenuItem
                            className="select__item"
                            value={value}
                            onKeyDown={onKeyDown}
                        >
                            <Typography className="select__item-text">
                                <>
                                    {getWord(label)}
                                    {span && (
                                        <Typography
                                            className="select__item-text_span"
                                            component="span"
                                        >
                                            {` (${getWord(span)})`}
                                        </Typography>
                                    )}
                                </>
                            </Typography>
                        </MenuItem>
                    );
                })}
            </Select>
            {typeof helperText === 'string' && (
                <FormHelperText
                    className="select__helper"
                    sx={{
                        fontSize: '11px',
                    }}
                >
                    {getWord(helperText)}
                </FormHelperText>
            )}
        </FormControl>
    );
};

const SelectComponent = React.memo(Component);

export default SelectComponent;
